import { useState, useEffect } from 'react';
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";
import { truncateEmail } from '../Utilities/utils';
import { useLocalStorage } from 'usehooks-ts';

const PROFILE_IMAGE = 'PROFILE_IMAGE';
const PROFILE_IMAGE_DATA = 'PROFILE_IMAGE_DATA';

const useProfileData = (fetchProfileImage = true) => {
  const [token, setToken] = useState();
  const [profileImage, setProfileImage] = useLocalStorage(PROFILE_IMAGE, '/DefaultProfile.png');
  const [profileImageData, setProfileImageData] = useLocalStorage(PROFILE_IMAGE_DATA, null);
  const [userName, setuserName] = useState();
  const [userEmail, setuserEmail] = useState();
  const { instance, accounts } = useMsal();
  const firstAccount = accounts[0];

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        // Obtener token para la API principal
        const apiResponse = await instance.acquireTokenSilent({
          ...loginRequest,
          account: firstAccount
        });

        // Actualizar el estado con la información del usuario
        setToken(firstAccount.idToken);
        setuserName(apiResponse.account.name);
        setuserEmail(truncateEmail(apiResponse.account.username, 50));

        // Obtener token específico para Microsoft Graph si se necesita la foto
        if (fetchProfileImage && profileImageData === null) {
          try {
            const graphResponse = await instance.acquireTokenSilent({
              scopes: ['User.Read'],
              account: firstAccount
            });

            const graphEndpoint = 'https://graph.microsoft.com/v1.0/me/photo/$value';
            const imageResponse = await fetch(graphEndpoint, {
              headers: {
                Authorization: `Bearer ${graphResponse.accessToken}`,
              },
            });

            if (imageResponse.ok) {
              const blob = await imageResponse.blob();
              const reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onload = () => {
                setProfileImage(reader.result);
                setProfileImageData({ data: blob });
              };
            }
          } catch (graphError) {
            console.error('Error fetching profile image:', graphError);
            setProfileImage('/DefaultProfile.png');
            setProfileImageData(null);
          }
        }
      } catch (error) {
        console.error('Error in profile data fetch:', error);
        
        // Manejo del error de MFA expirado (AADSTS50078)
        if (error instanceof InteractionRequiredAuthError || 
            (error.errorCode === 'interaction_required') || 
            (error.message && error.message.includes('AADSTS50078'))) {
          
          console.log('MFA expirado. Redirigiendo al flujo de autenticación interactiva...');
          
          // Iniciar flujo de autenticación interactiva para renovar MFA
          instance.acquireTokenRedirect({
            ...loginRequest,
            account: firstAccount
          }).catch(redirectError => {
            console.error('Error al iniciar redirección:', redirectError);
          });
        }
        
        setProfileImage('/DefaultProfile.png');
        setProfileImageData(null);
      }
    };

    if (firstAccount) {
      fetchProfileData();
    }
  }, [instance, firstAccount, fetchProfileImage, profileImageData, setProfileImage, setProfileImageData]);

  return { token, profileImage, userName, userEmail, profileImageData };
};

export default useProfileData;
